import { ModelSagres } from "../../model-sagres";
import { Contrato } from "./contrato";

export class ContratoLicitacaoOutraUg extends ModelSagres {
  IdContrato: number;
  IdUnidGestoraLicit: number;
  NrLicitacao: number;
  NrAnoLicitacao: number;
  IdModalidade: number;

  IdContratoNavigation: Contrato;
  //IdModalidadeNavigation: ModalidadeLicitacao;
}
